import CertificateWithoutRatingReview from "../../features/ServiceCertificateGrouping/PeerReviewFormCertificate/CertificateWithoutRating/CertificateWithoutRatingReview";
import "./CertificateGroupingWIthoutRatingReview.scss";

const CertificateGroupingWIthoutRatingReview = () => {
  return (
    <div className="analytics-page">
      <CertificateWithoutRatingReview />
    </div>
  );
};

export default CertificateGroupingWIthoutRatingReview;
